/**
 * Module for Google Maps.
 *
 * TODO;
 * + Add map styling.
 */


import Utility from 'utility/utility.js';


export const API_LOADED_EVENT_NAME = 'googleMapsAPILoaded';
export const DEFAULT_API_LANGUAGE  = 'sv';
export const DEFAULT_API_REGION    = 'SE';
export const DEFAULT_MAP_CENTER    =
{
	latitude  : 65.3166980,
	longitude : 21.4800363,
};
export const DEFAULT_ZOOM_LEVEL    = 15;
export const ACF_FIELD_NAMES       =
{
	'markerImage' : 'google-maps__marker-image',
	'latitude'    : 'google-maps__marker-latitude',
	'longitude'   : 'google-maps__marker-longitude',
};



/**
 * Class for Google Maps.
 *
 * @class      GoogleMaps (name)
 */
export class GoogleMaps
{
	/**
	 * Add necessary event listeners.
	 */
	static addListeners()
	{
		// Loop map sections
		$( 'section.google-maps' ).each(
			( index, elem ) =>
			{
				// Instantiate a new of current class
				let GoogleMapsInstance = new GoogleMaps();

				// Set elements
				GoogleMapsInstance.$section  = $( elem );
				GoogleMapsInstance.$wrapper  = GoogleMapsInstance.$section.find( '.google-maps__map-wrapper' );
				GoogleMapsInstance.markers   = JSON.parse( GoogleMapsInstance.$wrapper.attr( 'data-markers' ) );
				GoogleMapsInstance.zoomLevel = GoogleMapsInstance.$wrapper.attr( 'data-zoomlevel' );

				// Create map and add markers
				GoogleMapsInstance.setupMap();
			}
		);
	}





	/**
	 * Class constructor.
	 */
	constructor()
	{
		// Member variables
		this.$section;
		this.$wrapper;
		this.map;
		this.markers;
		this.zoomLevel;
	}





	/**
	 * Inspired by Facebook's SDK loading we'll run a VanillaJS implementation
	 * for minimum bullshit (and hey, if Facebook is doing it then it's gotta be
	 * pretty solid).
	 *
	 * NOTE: Since we're loading it on-demand it will only be available where a
	 * Google Maps section is actually used.
	 *
	 * @return     {Promise}  Promise that resolves once the API has been loaded
	 */
	loadAPI()
	{
		return new Promise(
			( resolve ) =>
			{
				// Make sure we don't run this twice
				if ( typeof window.googleMapsAPILoaded === 'undefined' )
				{
					// We're gonna load the API here, but we're not done (we differentiate between undefined and false so we can be absolutely sure we dont' accidentally start loading another instance before the first one has been loaded)
					window.googleMapsAPILoaded = false;

					// Setup our custom event
					let APILoadedEvent = document.createEvent( 'CustomEvent' );

					// Set event name
					APILoadedEvent.initEvent(
						API_LOADED_EVENT_NAME,
						true,
						true
					);


					// Setup our new script element
					let script = document.createElement( 'script' );

					// Find the first script element on the page
					let firstScript = document.getElementsByTagName( 'script' )[ 0 ];

					// Insert the script tag before the first other script tag we could find
					firstScript.parentNode.insertBefore(
						script,
						firstScript
					);

					// Set it to fire our custom event once script has loaded
					script.onload = () =>
					{
						// Indicate that this is already loaded
						window.googleMapsAPILoaded = true;

						// Run our custom event directly on the document object
						document.dispatchEvent( APILoadedEvent );

						// Resolve the promise
						return resolve();
					};


					// Set script source
					script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.$wrapper.attr( 'data-api-key' ) + '&language=' + DEFAULT_API_LANGUAGE + '&region=' + DEFAULT_API_REGION;
				}
				// Already loaded? Brilliant! (we keep it here instead of first to not have to match against typeof undefined as that's done by the first condition)
				else if ( true === window.googleMapsAPILoaded )
				{
					// Resolve it straight away
					return resolve();
				}
				// Started loading but hasn't finished...
				else
				{
					// Wait for the event to trigger and then resolve
					$( document ).on(
						API_LOADED_EVENT_NAME,
						() =>
						{
							return resolve();
						}
					);
				}
			}
		);
	}





	/**
	 * Sets up the map and markers.
	 */
	async setupMap()
	{
		// Make sure the API is loaded
		await this.loadAPI();

		// Create the map
		this.createMap();

		// Create the markers
		this.createMarkers();

		// Do we want have multiple markers?
		if ( 1 < this.markers.length )
		{
			// Makes sure all the markers fit into the map viewport
			this.fitAllMarkers();
		}
		// A single marker
		else if ( 1 === this.markers.length )
		{
			// Center on first marker
			this.map.setCenter(
				new window.google.maps.LatLng(
					this.markers[ 0 ][ ACF_FIELD_NAMES.latitude ],
					this.markers[ 0 ][ ACF_FIELD_NAMES.longitude ]
				)
			);
		}
	}





	/**
	 * Creates a new map object.
	 */
	createMap()
	{
		// Set map config to a variable so we can build it dynamically
		let mapConfig =
		{
			center            : new window.google.maps.LatLng(
				DEFAULT_MAP_CENTER.latitude,
				DEFAULT_MAP_CENTER.longitude
			),
			disableDefaultUI  : true,
			fullscreenControl : false,
			mapTypeControl    : false,
			scrollwheel       : false,
			streetViewControl : false,
			zoom              :
			(
				typeof this.zoomLevel !== 'undefined' && 0 < parseInt( this.zoomLevel )
					? parseInt( this.zoomLevel )
					: DEFAULT_ZOOM_LEVEL
			),
			zoomControl       : false,
		};

		// Do we have styling set?
		if ( true === Utility.Objects.isset( () => { return window.app.googleMaps.styling } ) )
		{
			// Apply it
			mapConfig.styles = window.app.googleMaps.styling;
		}

		// Create the actual map object
		this.map = new window.google.maps.Map(
			this.$wrapper[ 0 ],
			mapConfig
		);


		// Listen for window resizing and update center
		window.google.maps.event.addDomListener(
			window,
			'resize',
			() =>
			{
				// Set center to a temporary variable (as it may have been moved by the user since we instantiated the map)
				let center = this.map.getCenter();

				// Trigger a resize event on the map object (Why though? They said to do so here: https://stackoverflow.com/a/20675650 but I'm not sure I understand why it's necessary...)
				window.google.maps.event.trigger(
					this.map,
					'resize'
				);

				// Pan to the new center
				this.map.panTo( center );
			}
		);
	}





	/**
	 * Creates a marker on the current map.
	 */
	createMarkers()
	{
		// Set amount of markers to a variable for performance
		let markerCount = this.markers.length;

		// Loop markers
		for ( let i = 0; i < markerCount; i++ )
		{
			// Set mapconfig to a variable so we can configure it dynamically if necessa
			let markerConfig =
			{
				position : new window.google.maps.LatLng(
					this.markers[ i ][ ACF_FIELD_NAMES.latitude ],
					this.markers[ i ][ ACF_FIELD_NAMES.longitude ]
				),
				map      : this.map,
			};

			// Do we have a custom image to use?
			if ( typeof this.markers[ i ][ ACF_FIELD_NAMES.markerImage ] === 'string' )
			{
				// Set it as the icon
				markerConfig.icon = this.markers[ i ][ ACF_FIELD_NAMES.markerImage ];
			}

			// Set marker and assign it to our markers array
			this.markers[ i ].markerObject = new window.google.maps.Marker( markerConfig );
		}
	}





	/**
	 * Fits all markers within the map viewport.
	 */
	fitAllMarkers()
	{
		// Set amount of markers to a variable for performance
		let markerCount = this.markers.length;

		// Create an object to hold our map bounds
		let mapBounds = new google.maps.LatLngBounds();

		// Loop markers
		for ( let i = 0; i < markerCount; i++ )
		{
			// Extend the map bounds with this marker's position
			mapBounds.extend(
				new window.google.maps.LatLng(
					this.markers[ i ][ ACF_FIELD_NAMES.latitude ],
					this.markers[ i ][ ACF_FIELD_NAMES.longitude ]
				)
			);
		}

		// Set max zoom to current zoom level so we don't get zoomed in when fitting to bounds respected
		this.map.setOptions(
			{
				maxZoom: this.map.getZoom(),
			}
		);

		// Do the actual fitting
		this.map.fitBounds( mapBounds );

		// Center to the bounding box
		this.map.setCenter( mapBounds.getCenter() );

		// Wait for it to be done
		window.google.maps.event.addListenerOnce(
			this.map,
			'idle',
			() =>
			{
				// Reset max zoom so user zooming is respected
				this.map.setOptions(
					{
						maxZoom: undefined,
					}
				);
			}
		);
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/modules/google-maps/google-maps.js